export function bindNavToggle(toggle: HTMLButtonElement): void {
  const menu = document.getElementById(toggle.getAttribute('aria-controls') ?? '')
  if (!menu) return

  const setOpen = (open: boolean) => {
    menu.classList.toggle('open', open)
    toggle.setAttribute('aria-expanded', String(open))
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu')
  }

  toggle.addEventListener('click', () => setOpen(!menu.classList.contains('open')))
  menu.addEventListener('click', (event) => {
    if ((event.target as Element).closest('a')) setOpen(false)
  })
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.classList.contains('open')) {
      setOpen(false)
      toggle.focus()
    }
  })
  document.addEventListener('click', (event) => {
    const target = event.target as Node
    if (menu.classList.contains('open') && !menu.contains(target) && !toggle.contains(target)) setOpen(false)
  })
}
